module.exports = __webpack_public_path__ + "img/playMindWhite.95548704.svg";